import getCorePopUpStore from "../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import AddCommentPopUp from "./add-comment-pop-up";
import CleanPoolPopUp from "./clean-pool-pop-up";
import KhattabatClientAssignConfirmationPopUp from "./khattabat-client-assign-confirmation-pop-up";
import ReactivateKhattabaClientConfirmationPopUp from "./khattabat-reactivate-khattaba-client";
import ReactivateOneOTwoConfirmationPopUp from "./reactive-1o2-conv-pop-up";
import ResetAccountPopUp from "./reset-account-pop-up";
import ResetPasswordPopUp from "./reset-password-pop-up";
import KhattabatMatchingResultsPopUp from "./khattabat-matching-results-pop-up";
import KhattabatOneOTwoMessageHistoriesPopUp from "./khattabat-one-o-two-message-histories-pop-up";

const Et3ConfirmationPopUp = withLiteObserverAndTheme(() => {
  const popUpType = getCorePopUpStore().confirmationPopUpType.get();

  switch (popUpType) {
    case "RESET_ACCOUNT_POPUP":
      return <ResetAccountPopUp />;
    case "RESET_PASSWORD_POPUP":
      return <ResetPasswordPopUp />;
    case "ADD_COMMENT_POPUP":
      return <AddCommentPopUp />;
    case "CLEAN_POOL_CONFIRMATION_POPUP":
      return <CleanPoolPopUp />;
    case "ONE_O_TWO_CONFIRMATION_POPUP":
      return <ReactivateOneOTwoConfirmationPopUp />;
    case "KHATTABAT_CLIENT_ASSIGN_CONFIRMATION_POPUP":
      return <KhattabatClientAssignConfirmationPopUp />;
    case "REACTIVATE_KHATTABA_CLIENT_POPUP":
      return <ReactivateKhattabaClientConfirmationPopUp />;
    case "KHATTABAT_MATCHING_RESULTS_POPUP":
      return <KhattabatMatchingResultsPopUp />;
    case "KHATTABAT_ONE_O_TWO_MESSAGE_HISTORIES_POPUP":
      return <KhattabatOneOTwoMessageHistoriesPopUp />;
    default:
      return <></>;
  }
});
export default Et3ConfirmationPopUp;
